/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { RedactUI } from "@brighter-ai/portal-redact-ui";
import { RedactClient } from "@brighter-ai/portal-redact-client";
import { useGetOne } from "ra-core";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  redactUi: {
    minHeight: 630,
  },
  button: {
    textDecoration: "underline",
    color: theme.palette.info.main,
  },
}));

const FullRedaction = () => {
  const classes = useStyles();
  const { data } = useGetOne("api-keys", "");

  if (!data) {
    return <div></div>;
  }

  const primaryApiKey = data["primaryKey"];

  const redactClient = new RedactClient(
    "https://api.brighter.ai",
    primaryApiKey
  );

  return (
      <div className={classes.redactUi}>
        <RedactUI redactClient={redactClient} />
      </div>
  );
};

export default FullRedaction;
